export const SEQUENTIAL = 'SEQUENTIAL'
export const TABS = 'TABS'
export const RESPONSE_STATUS_COMPLETED = 'COMPLETED'